import React from 'react';
import { motion } from 'framer-motion';
import { Check, Target, AlertTriangle, Clock } from 'lucide-react';
const deliverables = ["El Manual Maestro 'El Código del Visto' (PDF).", "La Guía de 'Interrupción de Patrón': frases exactas para copiar y pegar.", 'Auditoría de Perfil: Cómo convertir tu WhatsApp en un imán de atención.', 'El Diccionario de Respuestas: Qué decir cuando por fin te buscan.', "El Método del 'Visto de Vuelta' para re-entrenar el interés de la otra persona."];
const faqs = [{
  q: '¿Funciona si ya pasaron semanas del último visto?',
  a: "Sí, el código tiene una técnica específica para 'chats fríos'."
}, {
  q: '¿Es difícil de aplicar?',
  a: 'No, es leer y copiar el guion que mejor se adapte a tu situación.'
}, {
  q: '¿Qué si no me contesta?',
  a: "El manual incluye el protocolo de 'Retirada Final' para que mantengas tu dignidad intacta."
}, {
  q: '¿Es para hombres o mujeres?',
  a: 'El deseo y la curiosidad funcionan igual en todos los cerebros humanos.'
}];
export const Details = () => {
  return <section className="py-12 md:py-24 bg-brand-dark relative" data-id="element-10">
      <div className="max-w-5xl mx-auto px-4 space-y-16 md:space-y-32" data-id="element-11">
        {/* What You Get */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-12">
          <div data-id="element-13">
            <h3 className="font-display text-3xl md:text-4xl text-white uppercase mb-5 md:mb-8 border-l-4 border-brand-red pl-3 md:pl-4" data-id="element-14">
              Lo que obtienes
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-15">
              {deliverables.map((item, i) => <li key={i} className="flex items-start space-x-3 bg-brand-darker p-3 md:p-4 border border-white/5" data-id="element-16">
                  <Check className="w-5 h-5 md:w-6 md:h-6 text-brand-red flex-shrink-0" data-id="element-17" />
                  <span className="text-brand-light text-sm md:text-base" data-id="element-18">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="space-y-8 md:space-y-12" data-id="element-19">
            {/* Who is this for */}
            <div data-id="element-20">
              <h4 className="font-display text-xl md:text-2xl text-white uppercase mb-4 md:mb-6 flex items-center" data-id="element-21">
                <Target className="w-5 h-5 md:w-6 md:h-6 mr-2 text-brand-blue" data-id="element-22" />{' '}
                Para quién es
              </h4>
              <ul className="space-y-2 md:space-y-3 text-brand-gray text-sm md:text-base" data-id="element-23">
                <li data-id="element-24">
                  • Personas cansadas de que les dejen de contestar sin razón.
                </li>
                <li data-id="element-25">
                  • Quien siente que siempre lleva la carga de la conversación.
                </li>
                <li data-id="element-26">• Hombres y mujeres que quieren recuperar su dignidad.</li>
                <li data-id="element-27">
                  • Usuarios de apps de citas que ven cómo sus chats se enfrían.
                </li>
              </ul>
            </div>

            {/* Who is NOT for */}
            <div data-id="element-28">
              <h4 className="font-display text-xl md:text-2xl text-white uppercase mb-4 md:mb-6 flex items-center" data-id="element-29">
                <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 mr-2 text-brand-red" data-id="element-30" />{' '}
                Para quién NO es
              </h4>
              <ul className="space-y-2 md:space-y-3 text-brand-gray text-sm md:text-base" data-id="element-31">
                <li data-id="element-32">• Personas que buscan terapia de pareja profunda.</li>
                <li data-id="element-33">
                  • Quien no está dispuesto a dejar el celular a un lado por
                  unas horas.
                </li>
                <li data-id="element-34">• Gente que busca manipular con maldad.</li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* How it works & Proof */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-darker border border-brand-blue/20 p-5 md:p-12 relative" data-id="element-35">
          <div className="absolute top-0 right-0 p-4 opacity-10 hidden md:block" data-id="element-36">
            <Clock className="w-32 h-32 text-brand-blue" data-id="element-37" />
          </div>
          <h3 className="font-display text-3xl md:text-4xl text-white uppercase mb-5 md:mb-8 relative z-10" data-id="element-38">
            El Proceso de 3 Pasos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 relative z-10 mb-8 md:mb-12" data-id="element-39">
            <div className="flex md:block items-start space-x-3 md:space-x-0 md:space-y-2" data-id="element-40">
              <span className="font-display text-2xl md:text-3xl text-brand-blue" data-id="element-41">
                01.
              </span>
              <p className="text-brand-light text-sm md:text-base" data-id="element-42">
                Identifica el error que cometiste en tu último chat usando la
                guía.
              </p>
            </div>
            <div className="flex md:block items-start space-x-3 md:space-x-0 md:space-y-2" data-id="element-43">
              <span className="font-display text-2xl md:text-3xl text-brand-blue" data-id="element-44">
                02.
              </span>
              <p className="text-brand-light text-sm md:text-base" data-id="element-45">
                Aplica uno de los 3 guiones de "Interrupción de Patrón" según tu
                caso.
              </p>
            </div>
            <div className="flex md:block items-start space-x-3 md:space-x-0 md:space-y-2" data-id="element-46">
              <span className="font-display text-2xl md:text-3xl text-brand-blue" data-id="element-47">
                03.
              </span>
              <p className="text-brand-light text-sm md:text-base" data-id="element-48">
                Ejecuta el "Visto de Vuelta" para reclamar tu estatus.
              </p>
            </div>
          </div>

          <div className="border-t border-white/10 pt-5 md:pt-8" data-id="element-49">
            <p className="text-base md:text-xl text-white font-medium leading-relaxed" data-id="element-50">
              <span className="text-brand-red" data-id="element-51">LA PROMESA:</span> En los
              próximos 7 días, tu percepción del valor cambiará. Dejarás de
              sentir esa presión en el pecho. Verás cómo, mágicamente, las
              personas que antes tardaban dos días en contestar, ahora te
              escriben en minutos porque no aguantan la curiosidad.
            </p>
          </div>
        </motion.div>

        {/* FAQ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-52">
          <h3 className="font-display text-3xl md:text-4xl text-white uppercase mb-5 md:mb-8 text-center" data-id="element-53">
            Preguntas Frecuentes
          </h3>
          <div className="grid md:grid-cols-2 gap-3 md:gap-6" data-id="element-54">
            {faqs.map((faq, i) => <div key={i} className="bg-brand-darker p-4 md:p-6 border border-white/5" data-id="element-55">
                <h4 className="text-white font-medium text-sm md:text-base mb-1 md:mb-2 flex justify-between items-start" data-id="element-56">
                  {faq.q}
                </h4>
                <p className="text-brand-gray text-xs md:text-sm leading-relaxed" data-id="element-57">
                  {faq.a}
                </p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};